<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span> <em name="Exhibition"></em> <span>/</span>
          <a href="javascript: history.back()">參展產品</a> <span>/</span>修改產品
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="contentBox">
        <div>
          <h1>修改產品</h1>
          <p class="my-3">&nbsp;</p>
          <div>
            <div class="alert" v-if="ProductWarning == 'N/A'" name="ProductWarning">
              <div>
                <i class="fas fa-exclamation-circle mr-1"></i>
                您建立之產品資料須符合相關單位之法規，如有任何爭議，主辦單位保留最終商品上架之決定權。
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i> 請確認調整在
                <u>產品圖片</u>
                與 <u>產品資訊</u> 後，須按下「確定送出」按鈕才算完成修改。
              </div>
            </div>
            <div class="alert" v-else-if="ProductWarning !== 'N/A'" name="ProductWarning">
              <div><i class="fas fa-exclamation-circle mr-1"></i> {{ ProductWarning }}</div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i> 請確認調整在
                <u>產品圖片</u>
                與 <u>產品資訊</u> 後，須按下「確定送出」按鈕才算完成修改。
              </div>
            </div>
          </div>
          <p class="my-3">&nbsp;</p>

          <form id="form" enctype="multipart/form-data" @submit.prevent="updateProduct">
            <!-- left -->

            <!-- PC版圖片顯示 -->

            <div class="proLeft PcDevice">
              <label class="inputFile">
                <div class="squareThumb pointer ImgHoverStyle">
                  <img :src="modelSrc" class="img-fluid" />
                </div>

                <p class="my-3">&nbsp;</p>
                <span name="showName" class="nowrap"></span>
                <input type="file" name="ProImg" accept=".JPG,.PNG" @change="uploadNewImgPC($event)" />
                <p class="divider"></p>
                <div class="d-flex justify-content-around">
                  <div>
                    <p class="align_c"><span class="btnStyle btnGray">選擇圖片</span></p>
                  </div>
                  <div v-if="modelSrc !== OImgSrc">
                    <p class="align_c">
                      <span class="btnStyle btnRed" @click.prevent="resetImg">重設圖片 </span>
                    </p>
                  </div>
                </div>
              </label>
              <div class="uploadAlert">
                <p class="italic">檔案大小：最大 3MB</p>
                <p class="italic">檔案限制：JPG、PNG</p>
                <p class="italic">建議尺寸：最低要求 500 x 500像素</p>
              </div>
            </div>

            <!-- 行動版圖片顯示 -->

            <div class="proLeft MbDevice">
              <label class="inputFile pointer">
                <div class="mb-3"><img :src="modelSrc" class="img-fluid" /></div>
                <p class="my-3">&nbsp;</p>
                <span name="showName" class="nowrap"></span>
                <input type="file" name="ProImg" accept=".JPG,.PNG" @change="uploadNewImgMb($event)" />
                <p class="divider"></p>
                <div class="d-flex justify-content-around">
                  <div>
                    <p class="align_c"><span class="btnStyle btnGray">選擇圖片</span></p>
                  </div>
                  <div v-if="modelSrc !== OImgSrc">
                    <p class="align_c">
                      <span class="btnStyle btnRed" @click.prevent="resetImg">重設圖片 </span>
                    </p>
                  </div>
                </div>
              </label>
              <div class="uploadAlert">
                <p class="italic">檔案大小：最大 3MB</p>
                <p class="italic">檔案限制：JPG、PNG</p>
                <p class="italic">建議尺寸：最低要求 500 x 500像素</p>
              </div>
            </div>
            <!-- left end -->
            <!-- right -->
            <div class="proRight">
              <p class="formTitle">官網狀態</p>

              <div v-if="productList.Archived == 1">
                <div class="pointer d-flex align-items-center" @click="ChangeArchived(1)">
                  <div>
                    <img src="@/assets/images/off-button.png" width="35px" class="mt-2 mr-2" />
                  </div>
                  <div>隱藏</div>
                </div>
              </div>
              <div v-else>
                <div class="pointer d-flex align-items-center" @click="ChangeArchived(0)">
                  <div>
                    <img src="@/assets/images/on-button.png" width="35px" class="mt-2 mr-2" />
                  </div>
                  <div>顯示</div>
                </div>
              </div>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">產品名稱 <span class="red">*</span></p>
              <div class="langTip">
                <input
                  type="text"
                  name="ProName"
                  class="textStyle maxText"
                  v-model="productList.ProName"
                  maxlength="200"
                  required
                />
                <span>中</span>
              </div>
              <p class="divider"></p>
              <div class="langTip">
                <input
                  type="text"
                  name="eProName"
                  class="textStyle maxText"
                  v-model="productList.eProName"
                  maxlength="200"
                />
                <span>EN</span>
              </div>

              <p class="my-3">&nbsp;</p>
              <div class="right">
                <p class="formTitle">產品型號</p>
                <input
                  type="text"
                  name="ProModel"
                  class="textStyle maxText mb-3"
                  v-model="productList.ProModel"
                  maxlength="50"
                />
              </div>
              <div class="left">
                <p class="formTitle">產品分類 <span class="red">*</span></p>

                <div v-if="hasProTwoCat">
                  <div
                    data-toggle="modal"
                    data-target="#SelectCatModal"
                    class="mt-3 pointer"
                    style="color: rgb(0, 153, 204); text-decoration: underline; font-size: 17px"
                    v-if="SelectCatName"
                  >
                    {{ MainCatName }} - {{ SelectCatName }}
                  </div>

                  <div
                    data-toggle="modal"
                    data-target="#SelectCatModal"
                    class="mt-3 pointer"
                    style="color: rgb(0, 153, 204); text-decoration: underline; font-size: 17px"
                    v-else
                  >
                    請點擊開啟選項
                  </div>
                </div>

                <div v-else>
                  <select class="form-control text-dark" v-model="optionCatNo" required>
                    <option value="">-- 請選擇 --</option>
                    <option v-for="item in ProductCategory" :value="item.CatNo">{{ item.CatName }}</option>
                  </select>
                </div>
              </div>
              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">產品特色 (中) <span class="red">*</span></p>
              <textarea
                name="ProDesc"
                rows="6"
                class="maxText textStyle"
                v-model="productList.ProDesc"
                required
                placeholder="中文"
              ></textarea>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">產品特色 (English)</p>
              <textarea
                name="eProDesc"
                rows="6"
                class="maxText textStyle"
                v-model="productList.eProDesc"
                placeholder="English"
              ></textarea>
            </div>
            <!-- right end -->
            <p class="clear"></p>
            <p class="my-3">&nbsp;</p>
            <div class="text-center PcDevice">
              <button class="btn btn-lg btn-primary mr-3" type="submit">確定送出</button>
              <button class="btn btn-lg btn-secondary" @click.prevent="backProPage">返回</button>
            </div>
            <div class="text-center MbDevice">
              <button class="btn btn-primary mr-3" type="submit">確定送出</button>
              <button class="btn btn-secondary" @click.prevent="backProPage">返回</button>
            </div>
          </form>

          <!-- 桌機板裁切工具 Modal  -->
          <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header d-flex justify-content-between">
                  <div class="modal-title" style="font-size: 25px">
                    <div class="d-flex align-self-center">
                      <div class="mr-3">
                        <img src="@/assets/images/cropImg.png" width="30px" />
                      </div>
                      <div style="font-size: 25px">編輯產品圖片</div>
                    </div>
                  </div>

                  <div type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </div>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-sm-8">
                      <div class="CropBoxStyle">
                        <vue-cropper
                          ref="cropper"
                          :img="option.img"
                          :output-size="option.size"
                          :output-type="option.outputType"
                          :info="true"
                          :full="option.full"
                          :fixed="fixed"
                          :can-move="option.canMove"
                          :can-move-box="option.canMoveBox"
                          :fixed-box="option.fixedBox"
                          :original="option.original"
                          :auto-crop="option.autoCrop"
                          :auto-crop-width="option.autoCropWidth"
                          :auto-crop-height="option.autoCropHeight"
                          :center-box="option.centerBox"
                          :high="option.high"
                          :max-img-size="option.max"
                          :fixed-number="fixedNumber"
                          :enlarge="option.enlarge"
                          :infoTrue="option.infoTrue"
                          :mode="option.mode"
                          @real-time="realTime"
                        >
                        </vue-cropper>
                      </div>

                      <div class="d-flex justify-content-between mt-3 mx-3">
                        <div>
                          <button @click="rotateLeft" class="btn btn-info">向左旋轉</button>
                          <button @click="rotateRight" class="btn btn-info ml-2">向右旋轉</button>
                          <button @click="changeScale(1)" class="btn btn-info ml-2">放大</button>
                          <button @click="changeScale(-1)" class="btn btn-info ml-2">縮小</button>
                        </div>
                        <div>
                          <button @click="refreshCrop" class="btn btn-outline-info">重設</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div :style="previewStyle1" class="ImgPreCrop">
                        <div :style="previews.div">
                          <img :src="previews.url" :style="previews.img" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="modal-footer">
                  <div>
                    <button type="button" id="cropImageBtn" class="btn btn-primary btn-lg mr-2" @click="OutputPC()">
                      裁切
                    </button>

                    <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal">關閉</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 選擇兩層產品類型 Modal  -->

          <div
            class="modal fade"
            id="SelectCatModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h3 class="modal-title font-weight-bold" id="exampleModalLabel">產品分類列表</h3>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <!-- <p class="my-3">請選擇一種產品類型</p> -->

                  <div class="mt-3">
                    <el-collapse v-model="Tab_Category">
                      <el-collapse-item
                        :title="`${index + 1}. ${item.mainCatName}`"
                        :name="index"
                        v-for="(item, index) in ProTwoCatList"
                        :key="index"
                      >
                        <div class="row">
                          <div class="col-lg-4 my-1" v-for="Category in ProTwoCatList[index].subCategory">
                            <div class="custom-control custom-radio custom-control-inline">
                              <input
                                class="custom-control-input"
                                type="radio"
                                name="inlineRadioOptions"
                                :value="Category.CatNo"
                                :id="Category.CatNo"
                                v-model="optionCatNo"
                              />
                              <label class="custom-control-label pointer" :for="Category.CatNo"
                                >{{ Category.CatName }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 行動版裁切工具 Modal  -->
          <div
            class="modal fade"
            id="cropperMb"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-body">
                  <p>&middot; 系統將自動調整圖片至正方形尺寸。</p>
                  <p>&middot; 如有裁切及編輯圖片之需求，請至 PC 裝置上傳圖片。</p>
                </div>

                <div class="modal-footer">
                  <button type="button" id="cropperMb" class="btn btn-sm btn-primary" @click="OutputMb()">確定</button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showImg" class="CropBoxStyle">
            <vue-cropper
              ref="cropper"
              :img="option.img"
              :output-size="option.size"
              :output-type="option.outputType"
              :info="true"
              :full="option.full"
              :fixed="fixed"
              :can-move="option.canMove"
              :can-move-box="option.canMoveBox"
              :fixed-box="option.fixedBox"
              :original="option.original"
              :auto-crop="option.autoCrop"
              :auto-crop-width="option.autoCropWidth"
              :auto-crop-height="option.autoCropHeight"
              :center-box="option.centerBox"
              :high="option.high"
              :max-img-size="option.max"
              :fixed-number="fixedNumber"
              :enlarge="option.enlarge"
              :infoTrue="option.infoTrue"
              :mode="option.mode"
            >
            </vue-cropper>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: '參展產品 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        showImg: false,
        CSRF_Token: '',
        RegNo: '',
        ProductWarning: '',
        ProductID: '',
        productList: [],
        ProductCategory: [],
        ProTwoCatList: [],
        hasProTwoCat: false,
        ProductCatNo: '',
        SelectCat: [],

        previews: {},
        previewStyle1: {},
        modelSrc: '',
        OImgSrc: '', // 原始圖片

        option: {
          img: '', // 裁剪图片的地址
          max: 9999, //限制图片最大宽度和高度
          enlarge: 1,
          mode: 'contain',

          centerBox: false, // 截图框是否被限制在图片里面
          canMove: true, //上传图片是否可以移动
          infoTrue: true,

          fixedBox: true, // 固定截图框大小 不允许改变
          canMoveBox: false, // 截图框能否拖动
          autoCrop: true, // 是否默认生成截图框
          // 只有自动截图开启 宽度高度才生效
          autoCropWidth: 500, // 默认生成截图框宽度
          autoCropHeight: 500,

          full: false, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
          high: false, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
          original: false, // 上传图片按照原始比例渲染

          size: 0.7, //裁剪生成图片的质量
          outputType: 'png', // 裁剪生成图片的格式
        },

        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        lang: 'tw',

        currentPage: 0,
        optionAr: false,

        initialLogo: '',

        Tab_Category: [0],
        SelectCatName: '',
        MainCatName: '',

        optionCatNo: '', //產品類別號碼
      }
    },

    watch: {
      optionCatNo: function (newValue) {
        let ShowName = this.ProductCategory.filter(function (item) {
          return item.CatNo == newValue
        })
        this.SelectCatName = ShowName[0].CatName
        let GetCatName = this.ProTwoCatList.filter(function (item) {
          return item.subCategory.find(function (item2) {
            return item2.CatNo == newValue
          })
        })
        this.MainCatName = GetCatName[0].mainCatName
        $('#SelectCatModal').modal('hide')
      },
    },

    methods: {
      resetImg() {
        const vm = this
        vm.modelSrc = vm.OImgSrc
      },

      ChangeArchived(status) {
        const vm = this

        if (status == 1) {
          vm.$set(vm.productList, 'Archived', 0)
        } else {
          vm.$set(vm.productList, 'Archived', 1)
        }
      },

      updateProduct() {
        const vm = this
        const url = `/apiExhibitors/Product/${vm.RegNo}/${vm.ProductID}`

        if (vm.modelSrc == vm.initialLogo) {
          // console.log(33)
          var info2 = {
            CSRF: vm.CSRF_Token,
            ProImg: '',
            category: vm.optionCatNo,
            ProName: vm.productList.ProName,
            eProName: vm.productList.eProName,
            ProModel: vm.productList.ProModel,
            ProDesc: vm.productList.ProDesc,
            eProDesc: vm.productList.eProDesc,
            Archived: vm.productList.Archived,
          }
        } else {
          // console.log(66)

          var info2 = {
            CSRF: vm.CSRF_Token,
            ProImg: vm.modelSrc,
            category: vm.optionCatNo,
            ProName: vm.productList.ProName,
            eProName: vm.productList.eProName,
            ProModel: vm.productList.ProModel,
            ProDesc: vm.productList.ProDesc,
            eProDesc: vm.productList.eProDesc,
            Archived: vm.productList.Archived,
          }
        }

        // console.log(info)

        if (!vm.optionCatNo || !vm.productList.ProName || !vm.productList.ProDesc) {
          alert('輸入欄位不完整，請重新檢查！')
        } else {
          axios.post(url, info2).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              // alert('您已成功修改產品內容！')

              if (vm.currentPage == 0) {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
              } else {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}&Page=${vm.currentPage}`
              }
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('圖片檔案上傳錯誤！')
            }
          })
        }
      },

      uploadNewImgPC(e) {
        const vm = this

        let file = e.target.files[0]
        if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
          alert('上傳檔案類型必須是 JPG,PNG！')
          return false
        }

        let reader = new FileReader()

        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3

          // console.log(e)
          if (isLt5M) {
            $('#cropImagePop').modal('show')

            $('#cropImagePop').on('shown.bs.modal', function () {
              vm.option.img = window.URL.createObjectURL(new Blob([e.target.result]))
            })
          } else {
            alert('上傳圖片大小請勿超過 3MB！')
          }
        }

        reader.readAsArrayBuffer(file)
        e.target.value = ''
      },

      uploadEnNewImgPC(e) {
        const vm = this

        let file = e.target.files[0]
        if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
          alert('Upload file must be in JPG or PNG！')
          return false
        }

        let reader = new FileReader()

        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3

          // console.log(e)
          if (isLt5M) {
            $('#cropImagePop').modal('show')

            $('#cropImagePop').on('shown.bs.modal', function () {
              vm.option.img = window.URL.createObjectURL(new Blob([e.target.result]))
            })
          } else {
            alert('Maximum file size : 3MB')
          }
        }

        reader.readAsArrayBuffer(file)
        e.target.value = ''
      },

      uploadNewImgMb(e) {
        const vm = this

        //上传图片
        // this.option.img
        var file = e.target.files[0]
        if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
          alert('上傳檔案類型必須是 JPG,PNG！')
          return false
        }
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)

        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3

          if (isLt5M) {
            this.option.img = window.URL.createObjectURL(new Blob([e.target.result]))
            vm.showImg = true
            $('#cropperMb').modal('show')
          } else {
            alert('上傳圖片大小請勿超過 3MB！')
          }
        }
        e.target.value = ''
      },

      uploadEnNewImgMb(e) {
        const vm = this

        //上传图片
        // this.option.img
        var file = e.target.files[0]
        if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
          alert('Upload file must be in JPG or PNG！ ')
          return false
        }
        var reader = new FileReader()
        reader.readAsArrayBuffer(file)

        reader.onload = (e) => {
          const isLt5M = e.total / 1024 / 1024 < 3

          if (isLt5M) {
            this.option.img = window.URL.createObjectURL(new Blob([e.target.result]))
            vm.showImg = true
            $('#cropperMb').modal('show')
          } else {
            alert('Maximum file size : 3MB')
          }
        }
        e.target.value = ''
      },

      OutputPC() {
        const vm = this

        this.$refs.cropper.getCropData((data) => {
          // console.log(data)
          this.modelSrc = data
          $('#cropImagePop').modal('hide')

          $('#cropImagePop').on('hidden.bs.modal', function (e) {
            vm.option.img = '/'
          })

          window.setTimeout(() => alert('恭喜您成功更改圖片，提醒您需按下「確認送出」鍵，以完成修改產品之程序。'), 1000)
        })
      },

      OutputEnPC() {
        const vm = this

        this.$refs.cropper.getCropData((data) => {
          // console.log(data)
          this.modelSrc = data
          $('#cropImagePop').modal('hide')

          $('#cropImagePop').on('hidden.bs.modal', function (e) {
            vm.option.img = '/'
          })
          window.setTimeout(
            () =>
              alert(
                'After you change the product picture, please click "Confirm" to ensure the revision has been completed.'
              ),
            1000
          )
        })
      },

      OutputMb() {
        // 输出
        const vm = this

        this.$refs.cropper.getCropData((data) => {
          // console.log(data)
          this.modelSrc = data
        })

        $('#cropperMb').modal('hide')
        vm.showImg = false

        window.setTimeout(() => alert('恭喜您成功更改圖片，提醒您需按下「確認送出」鍵，以完成修改產品之程序。'), 1000)
      },

      OutputEnMb() {
        // 输出
        const vm = this

        this.$refs.cropper.getCropData((data) => {
          // console.log(data)
          this.modelSrc = data
        })

        $('#cropperMb').modal('hide')
        vm.showImg = false

        window.setTimeout(
          () =>
            alert(
              'After you change the product picture, please click "Confirm" to ensure the revision has been completed.'
            ),
          1000
        )
      },

      realTime(data) {
        var previews = data
        var h = 0.5
        var w = 0.2

        this.previewStyle1 = {
          width: previews.w + 'px',
          height: previews.h + 'px',
          overflow: 'hidden',
          margin: '0',
          zoom: h,
        }

        this.previews = data
      },

      rotateLeft() {
        this.$refs.cropper.rotateLeft()
      },
      rotateRight() {
        this.$refs.cropper.rotateRight()
      },

      changeScale(num) {
        num = num || 1
        this.$refs.cropper.changeScale(num)
      },

      refreshCrop() {
        this.$refs.cropper.refresh()
      },

      backProPage() {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`
        }
      },
    },

    created() {
      const vm = this

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1].split('&')[0]
      vm.ProductID = currentUrl.split('id=')[1].split('&')[0]

      if (currentUrl.split('Page=')[1]) {
        vm.currentPage = currentUrl.split('Page=')[1]
      }

      let url = `/apiExhibitors/Product/${vm.RegNo}/${vm.ProductID}`
      axios
        .get(url)
        .then(function (response) {
          if (response.data.Data) {
            vm.productList = response.data.Data
            vm.optionCatNo = vm.productList.CatNo

            if (vm.productList.Archived == 0) {
              vm.optionArchived = true
            } else {
              vm.optionArchived = false
            }

            vm.ProductCatNo = vm.productList.CatNo
            vm.modelSrc = `//www.chanchao.com.tw/exhibitorServicefiles/products/${response.data.Data.ProImg}`
            vm.OImgSrc = `//www.chanchao.com.tw/exhibitorServicefiles/products/${response.data.Data.ProImg}`
            vm.initialLogo = `//www.chanchao.com.tw/exhibitorServicefiles/products/${response.data.Data.ProImg}`

            //取得產品類別列表
            let url2 = `/apiExhibitors/ProductCategory/${vm.RegNo}`
            axios.get(url2).then(function (response) {
              vm.ProductCategory = response.data.Data

              let ShowName2 = vm.ProductCategory.filter(function (item) {
                return item.CatNo == vm.optionCatNo
              })
              vm.SelectCatName = ShowName2[0].CatName

              //取得產品欄位警語
              axios.get(`/apiExhibitors/ProductWarning/${vm.RegNo}?lang=${vm.lang}`).then(function (response) {
                // console.log(response)
                vm.ProductWarning = response.data.Data.ProductWarning
              })
            })

            //取得產品類別列表
            let url3 = `/apiExhibitors/ProductCategoryTwoLayer/${vm.RegNo}`
            axios.get(url3).then(function (response) {
              // console.log(response)

              if (response.data.Code == 200) {
                vm.ProTwoCatList = response.data.Data

                let GetCatName2 = vm.ProTwoCatList.filter(function (item) {
                  return item.subCategory.find(function (item2) {
                    return item2.CatNo == vm.optionCatNo
                  })
                })
                vm.MainCatName = GetCatName2[0].mainCatName

                vm.hasProTwoCat = true
              } else {
                vm.hasProTwoCat = false
              }
            })

            //對照雙層的產品分類
          } else {
            alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
          }
        })
        .catch((err) => {
          alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
        })
    },
  }
</script>

<style lang="scss">
  .form-control {
    height: calc(2.2em + 0.75rem + 2px);
  }

  // @media screen and (min-width: 331px) and (max-width: 576px) {
  //   .modal-content {
  //     width: 65%;
  //   }
  // }

  // @media screen and (max-width: 330px) {
  //   .modal-content {
  //     width: 60%;
  //   }
  // }

  .modal-xl {
    max-width: 940px;
  }

  .modal-body {
    height: 75vh;
    overflow-y: auto;
  }

  .custom-control-label {
    font-size: 15px;
  }

  .el-collapse-item__header {
    font-size: 17px;
    font-weight: 550;
  }
</style>
